import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableButton } from '@app/interfaces';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  @Input() title: string;
  @Input() visible: boolean;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() buttons: TableButton[];
  @Output() successHandler = new EventEmitter();
  
  constructor() { }

  ngOnInit(): void {
  }

  onClose() {
    this.visibleChange.emit(this.visible)
  }

  onClick(event: TableButton) {
    if(event.eventName == 'okay') {
      this.successHandler.emit(event);
      this.visible = false
    } else if (event.eventName == 'cancel') {
      this.visible = false
    }
  }

}
